import React from 'react';
import styles from './Sidebar.module.css';
import { NAV_ITEMS } from './navItems';

type SidebarProps = {
  activeItem: string;
  onNavigate: (id: string) => void;
};

function Sidebar({ activeItem, onNavigate }: SidebarProps): React.ReactElement {
  return (
    <nav className={styles.sidebar}>
      <span className={styles.sectionLabel}>Navigation</span>
      <ul className={styles.navList}>
        {NAV_ITEMS.map((item) => (
          <li key={item.id}>
            <button
              className={[
                styles.navItem,
                activeItem === item.id ? styles.navItemActive : '',
              ].join(' ')}
              onClick={() => onNavigate(item.id)}
            >
              {item.label}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default Sidebar;
